/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ContagemPorStatusResponse,
  ErroResponse,
  MateriaisAdminControllerListarParams,
  MaterialAdminResponse,
  PaginaDeMateriaisAdminResponse,
  RejeitarMaterialDto
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getMateriaisAdminControllerListarUrl = (params?: MateriaisAdminControllerListarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/materiais?${stringifiedParams}` : `/v1/admin/materiais`
}

/**
 * @summary Lista os materiais, paginado. Filtra por status e por parceiro.
 */
export const materiaisAdminControllerListar = async (params?: MateriaisAdminControllerListarParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeMateriaisAdminResponse> => {

  return httpClient<PaginaDeMateriaisAdminResponse>(getMateriaisAdminControllerListarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMateriaisAdminControllerListarQueryKey = (params?: MateriaisAdminControllerListarParams,) => {
    return [
    `/v1/admin/materiais`, ...(params ? [params] : [])
    ] as const;
    }


export const getMateriaisAdminControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof materiaisAdminControllerListar>>, TError = ErroResponse>(params?: MateriaisAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof materiaisAdminControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMateriaisAdminControllerListarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof materiaisAdminControllerListar>>> = ({ signal }) => materiaisAdminControllerListar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof materiaisAdminControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MateriaisAdminControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof materiaisAdminControllerListar>>>
export type MateriaisAdminControllerListarQueryError = ErroResponse


export function useMateriaisAdminControllerListar<TData = Awaited<ReturnType<typeof materiaisAdminControllerListar>>, TError = ErroResponse>(
 params: undefined |  MateriaisAdminControllerListarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof materiaisAdminControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof materiaisAdminControllerListar>>,
          TError,
          Awaited<ReturnType<typeof materiaisAdminControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMateriaisAdminControllerListar<TData = Awaited<ReturnType<typeof materiaisAdminControllerListar>>, TError = ErroResponse>(
 params?: MateriaisAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof materiaisAdminControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof materiaisAdminControllerListar>>,
          TError,
          Awaited<ReturnType<typeof materiaisAdminControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMateriaisAdminControllerListar<TData = Awaited<ReturnType<typeof materiaisAdminControllerListar>>, TError = ErroResponse>(
 params?: MateriaisAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof materiaisAdminControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os materiais, paginado. Filtra por status e por parceiro.
 */

export function useMateriaisAdminControllerListar<TData = Awaited<ReturnType<typeof materiaisAdminControllerListar>>, TError = ErroResponse>(
 params?: MateriaisAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof materiaisAdminControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMateriaisAdminControllerListarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMateriaisAdminControllerContarUrl = () => {




  return `/v1/admin/materiais/contagem`
}

/**
 * @summary Quantos há em cada status. O de pendentes vira badge no menu.
 */
export const materiaisAdminControllerContar = async ( options?: Parameters<typeof httpClient>[1]): Promise<ContagemPorStatusResponse> => {

  return httpClient<ContagemPorStatusResponse>(getMateriaisAdminControllerContarUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMateriaisAdminControllerContarQueryKey = () => {
    return [
    `/v1/admin/materiais/contagem`
    ] as const;
    }


export const getMateriaisAdminControllerContarQueryOptions = <TData = Awaited<ReturnType<typeof materiaisAdminControllerContar>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof materiaisAdminControllerContar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMateriaisAdminControllerContarQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof materiaisAdminControllerContar>>> = ({ signal }) => materiaisAdminControllerContar({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof materiaisAdminControllerContar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MateriaisAdminControllerContarQueryResult = NonNullable<Awaited<ReturnType<typeof materiaisAdminControllerContar>>>
export type MateriaisAdminControllerContarQueryError = unknown


export function useMateriaisAdminControllerContar<TData = Awaited<ReturnType<typeof materiaisAdminControllerContar>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof materiaisAdminControllerContar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof materiaisAdminControllerContar>>,
          TError,
          Awaited<ReturnType<typeof materiaisAdminControllerContar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMateriaisAdminControllerContar<TData = Awaited<ReturnType<typeof materiaisAdminControllerContar>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof materiaisAdminControllerContar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof materiaisAdminControllerContar>>,
          TError,
          Awaited<ReturnType<typeof materiaisAdminControllerContar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMateriaisAdminControllerContar<TData = Awaited<ReturnType<typeof materiaisAdminControllerContar>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof materiaisAdminControllerContar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Quantos há em cada status. O de pendentes vira badge no menu.
 */

export function useMateriaisAdminControllerContar<TData = Awaited<ReturnType<typeof materiaisAdminControllerContar>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof materiaisAdminControllerContar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMateriaisAdminControllerContarQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMateriaisAdminControllerAprovarUrl = (id: string,) => {




  return `/v1/admin/materiais/${id}/aprovar`
}

/**
 * @summary Publica o material na vitrine do parceiro
 */
export const materiaisAdminControllerAprovar = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<MaterialAdminResponse> => {

  return httpClient<MaterialAdminResponse>(getMateriaisAdminControllerAprovarUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMateriaisAdminControllerAprovarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof materiaisAdminControllerAprovar>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof materiaisAdminControllerAprovar>>, TError,{id: string}, TContext> => {

const mutationKey = ['materiaisAdminControllerAprovar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof materiaisAdminControllerAprovar>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  materiaisAdminControllerAprovar(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MateriaisAdminControllerAprovarMutationResult = NonNullable<Awaited<ReturnType<typeof materiaisAdminControllerAprovar>>>

    export type MateriaisAdminControllerAprovarMutationError = ErroResponse

    /**
 * @summary Publica o material na vitrine do parceiro
 */
export const useMateriaisAdminControllerAprovar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof materiaisAdminControllerAprovar>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof materiaisAdminControllerAprovar>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getMateriaisAdminControllerAprovarMutationOptions(options), queryClient);
    }
    export const getMateriaisAdminControllerRejeitarUrl = (id: string,) => {




  return `/v1/admin/materiais/${id}/rejeitar`
}

/**
 * @summary Recusa com motivo. O parceiro lê o texto e pode reenviar.
 */
export const materiaisAdminControllerRejeitar = async (id: string,
    rejeitarMaterialDto: RejeitarMaterialDto, options?: Parameters<typeof httpClient>[1]): Promise<MaterialAdminResponse> => {

  return httpClient<MaterialAdminResponse>(getMateriaisAdminControllerRejeitarUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(rejeitarMaterialDto)
  }
);}





export const getMateriaisAdminControllerRejeitarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof materiaisAdminControllerRejeitar>>, TError,{id: string;data: RejeitarMaterialDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof materiaisAdminControllerRejeitar>>, TError,{id: string;data: RejeitarMaterialDto}, TContext> => {

const mutationKey = ['materiaisAdminControllerRejeitar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof materiaisAdminControllerRejeitar>>, {id: string;data: RejeitarMaterialDto}> = (props) => {
          const {id,data} = props ?? {};

          return  materiaisAdminControllerRejeitar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MateriaisAdminControllerRejeitarMutationResult = NonNullable<Awaited<ReturnType<typeof materiaisAdminControllerRejeitar>>>
    export type MateriaisAdminControllerRejeitarMutationBody = RejeitarMaterialDto
    export type MateriaisAdminControllerRejeitarMutationError = ErroResponse

    /**
 * @summary Recusa com motivo. O parceiro lê o texto e pode reenviar.
 */
export const useMateriaisAdminControllerRejeitar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof materiaisAdminControllerRejeitar>>, TError,{id: string;data: RejeitarMaterialDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof materiaisAdminControllerRejeitar>>,
        TError,
        {id: string;data: RejeitarMaterialDto},
        TContext
      > => {
      return useMutation(getMateriaisAdminControllerRejeitarMutationOptions(options), queryClient);
    }
